import React, {FC} from "react";
import {css} from "@emotion/react";

import {borderRadius} from "@pg-design/helpers-css";

interface IProps {
    children: React.ReactNode;
}

export const DetailSectionWrapper: FC<IProps> = (props) => {
    return <div css={wrapper}>{props.children}</div>;
};

const wrapper = css`
    ${borderRadius(2)}
    background-color: #fff;
    padding: 2.4rem 2.4rem 3.2rem 2.4rem;
`;
import React, {FC} from "react";
import {css} from "@emotion/react";

import {borderRadius} from "@pg-design/helpers-css";

interface IProps {
    children: React.ReactNode;
}

export const DetailSectionWrapper: FC<IProps> = (props) => {
    return <div css={wrapper}>{props.children}</div>;
};

const wrapper = css`
    ${borderRadius(2)}
    background-color: #fff;
    padding: 2.4rem 2.4rem 3.2rem 2.4rem;
`;
